<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <health-explorer-controls-user-select
          v-model="selectedUser"
          v-on:click="requestData"
          v-show="!disableUserSelect"
          v-on:hidden="hiddeComp"
        />
      </div>
    </div>
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="3">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.back()"/>
              {{ $t('health.nutritionalPlan.title') }}
            </h1>
            <div class="right">
                  <span
                    v-tooltip.left.top-start="$t('health.nutritionalPlan.addIngest')"
                    @click="createPlan"
                  >
                    <font-awesome-icon
                      class="header-add-button-icon"
                      :icon="icon.add"/>
                  </span>
            </div>
          </div>
          </grid-col>
          <grid-col col-size="1">
          <div class="right">
            <h3>{{$t('health.nutritionalPlan.modeTitle')}}:</h3>
            <radio
              v-for="(mode, index) in getNutritionalPlanModes"
              :key="index"
              v-on:change="onNutritionalModeSelected(mode)"
              :checked="isModeChecked(mode)"
              radio-size="s"
              :id="String(mode.id)"
              :label="mode.label"/>
          </div>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <div v-if="maxSelected.length > 0">
        <grid-row class="margin-top-m" column-align="center">
          <grid-col col-size="4">
            <span class="margin-right-l">
              <font-awesome-icon
                class="warning-icon"
                :icon="icon.warning"/>
              </span>
            {{ $t('health.nutritionalPlan.maxIngestsOfType') + ': ' + maxSelected.join(', ') }}
          </grid-col>
        </grid-row>
      </div>
      <div v-if="noWeight">
        <grid-row class="margin-top-m" column-align="center">
          <grid-col col-size="4">
            <span class="margin-right-l">
              <font-awesome-icon
                class="warning-icon"
                :icon="icon.warning"/>
              </span>
            {{ $t('health.nutritionalPlan.noWeight') }}
          </grid-col>
        </grid-row>
      </div>
      <grid-row v-if="showCarbsFactor" class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <table-component
            ref="planTable"
            :data="fetchData"
            :show-caption="false"
            class="datatable"
            :show-filter="true">
            <table-column show="id" label="Id" :hidden="true"></table-column>
            <table-column
              show="name"
              :label="$t('health.nutritionalPlan.name')"
              header-class="text-left"
              cell-class="table-component__text-left">
            </table-column>
            <table-column
              show="typeText"
              :label="$t('health.nutritionalPlan.type')"
              header-class="text-left"
              cell-class="table-component__danger">
            </table-column>
            <table-column
              show="carbsFactor"
              :label="$t('health.nutritionalPlan.carbsFactor')"
              header-class="text-left"
              cell-class="table-component__danger">
            </table-column>

            <table-column :label="$t('health.nutritionalPlan.show')"
                          :sortable="true"
                          :filterable="false"
                          header-class="table-component__minimum__width__column">
              <template slot-scope="row">
                <checkbox v-on:change="changeSelected($event, row.id)"
                          :checked="isActive(row.id)"
                          :id="String(row.id)"
                          check-size="m"/>
              </template>
            </table-column>

            <table-column
              label=""
              :sortable="false"
              :filterable="false"
              header-class="table-component__minimum__width__column"
              cell-class="text-center">
              <template slot-scope="row">
                <grid-row column-align="center" col-spaced>
                  <grid-col col-size="2">
                    <font-awesome-icon
                      :id="row"
                      v-on:click="onUpdate(row)"
                      :icon="icon.pencil"
                      class="table-iconset-icon"/>
                  </grid-col>
                  <grid-col col-size="2">
                    <font-awesome-icon
                      v-on:click="onDelete(row)"
                      :icon="icon.trash"
                      class="table-iconset-icon"/>
                  </grid-col>
                </grid-row>
              </template>
            </table-column>
          </table-component>
        </grid-col>
      </grid-row>
      <grid-row v-else class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <table-component
            ref="planTable"
            :data="fetchData"
            :show-caption="false"
            class="datatable"
            :show-filter="true">
            <table-column show="id" label="Id" :hidden="true"></table-column>
            <table-column
              show="name"
              :label="$t('health.nutritionalPlan.name')"
              header-class="text-left"
              cell-class="table-component__text-left">
            </table-column>
            <table-column
              show="typeText"
              :label="$t('health.nutritionalPlan.type')"
              header-class="text-left"
              cell-class="table-component__danger">
            </table-column>

            <table-column label=""
                          :sortable="true"
                          :filterable="false"
                          header-class="table-component__minimum__width__column">
              <template slot-scope="row">
                <checkbox v-on:change="changeSelected($event, row.id)"
                          :checked="isActive(row.id)"
                          :disabled="maxIngestSelected(row) && !row.active"
                          :id="String(row.id)"
                          check-size="m"/>
              </template>
            </table-column>

            <table-column
              label=""
              :sortable="false"
              :filterable="false"
              header-class="table-component__minimum__width__column"
              cell-class="text-center">
              <template slot-scope="row">
                <font-awesome-icon
                  :id="row"
                  v-on:click="onUpdate(row)"
                  :icon="icon.pencil"
                  class="table-iconset-icon"/>
              </template>
            </table-column>

            <table-column
              label=""
              :sortable="false"
              :filterable="false"
              header-class="table-component__minimum__width__column"
              cell-class="text-center">
              <template slot-scope="row">
                <font-awesome-icon
                  v-on:click="onDelete(row)"
                  :icon="icon.trash"
                  class="table-iconset-icon"/>
              </template>
            </table-column>
          </table-component>
        </grid-col>
      </grid-row>

    </div>

    <ok-cancel-modal
      v-if="showConfirmationDeleteModal"
      v-on:ok="onDeleteConfirm"
      v-on:cancel="onDeleteCancel"
      :title="deleteModalMessage"
      :message="deleteModalMessage"
      :okButton="$t('commons.delete')"
      :cancelButton="$t('commons.cancel')">
      <div slot="body">
        <ul>
          <li>
            {{ planToDelete.name }}
          </li>
        </ul>
      </div>
    </ok-cancel-modal>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts//MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import Checkbox from '@/components/shared/forms/Checkbox';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';
import {faPlusCircle, faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons';
import {faPencilAlt, faTrashAlt} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import api from 'BRAND/api/nutritionPlan';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import Alert from '@/components/shared/alert/Alert';
import userApi from '@/api/user';
import pagination from '@/components/shared/table/pagination';
import Radio from '@/components/shared/forms/Radio';

export default {
  name: 'IngestList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron,
    HealthExplorerControlsUserSelect,
    TableColumn,
    TableComponent,
    TableRow,
    FontAwesomeIcon,
    Checkbox,
    OkCancelModal,
    Alert,
    Radio
  },

  data () {
    return {
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      showConfirmationDeleteModal: false,
      planToDelete: undefined,
      deleteModalMessage: '',
      disableUserSelect: false,
      noWeight: true,
      maxTypePlans: 10,
      weight: null,
      selectedUser: null,
      mode: null,
      showCarbsFactor: false,
      plans: [],
      icon: {
        add: faPlusCircle,
        trash: faTrashAlt,
        pencil: faPencilAlt,
        warning: faExclamationTriangle
      },
      maxSelected: [],
      mealTypes: [
        'Desayuno',
        'Almuerzo',
        'Comida',
        'Merienda',
        'Cena'
      ],
      tablePageSize: 15,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      gramsKilo: 'gramsKilo',
      percentage: 'percentage',
      free: 'free'
    };
  },
  watch: {
    value: {
      handler: function (value) {
        this.variable = value;
      }
    },
    mode: {
      handler: function () {
        this.showCarbsFactor = this.mode.alias === this.gramsKilo;
      }
    },
    selectedUser: {
      handler: function () {
        this.requestData();
      }
    },
    getPlans: {
      handler: function () {
        this.updateMaxSelectedIngestList();
        this.$refs.planTable.refresh();
      }
    }
  },
  mounted () {
    const userId = this.$route.params.userId;
    if (userId) {
      this.selectedUser = userId;
    }
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.workspace'),
          link: '/workspace'
        },
        {
          name: this.$t('health.nutritionalPlan.menu'),
          link: '/nutritionalPlan/menu'
        },
        {
          name: this.$t('health.nutritionalPlan.title'),
          link: '/ingest/',
          disabled: true
        }
      ];
    },
    getPlans () {
      return this.plans;
    },
    getNutritionalPlanModes () {
      return [
        {id: 0, label: this.$t('health.nutritionalPlan.gramsKilo'), alias: this.gramsKilo},
        {id: 2, label: this.$t('health.nutritionalPlan.free'), alias: this.free}
      ];
    }
  },
  methods: {
    requestData () {
      if (this.selectedUser != null) {
        api.getAllUserPlans(this, this.selectedUser).then(data => {
          this.plans = data;
          this.plans.forEach(value => {
            const typeIndex = this.mealTypes.findIndex((e) => e === value.type);
            value.typeText = this.$t('health.nutritionalPlan.mealTypes')[typeIndex];
          });
        });
        api.getNutritionPlanMode(this, this.selectedUser).then(data => {
          this.mode = this.getNutritionalPlanModes.find(value => value.alias === data);
          if (data === 'gramsKilo') {
            userApi.getUserProfile(this, this.selectedUser).then(data => {
              if (data.weight == null || data.weight === 0) {
                this.noWeight = true;
                this.weight = null;
              } else {
                this.weight = data.weight;
                this.noWeight = false;
              }
            });
          }
        });
      }
    },
    fetchData ({page, filter, sort}) {
      page = page === null || isNaN(page) ? 1 : page;
      const tablePage = pagination.createPage(
        this.getPlans,
        this.tableState,
        ['name'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.requestData();
      }
    },
    changeSelected (isChecked, planId) {
      const foundPlans = this.plans.find(value => value.id === planId);
      foundPlans.active = isChecked;
      this.updateMaxSelectedIngestList();
      api.updatePlan(this, foundPlans).then(() => {
        showAlert(this, this.$t('health.nutritionalPlan.successUpdateVisibility'), 'success');
      }, () => {
        showAlert(this, this.$t('health.nutritionalPlan.errorUpdateVisibility'), 'error');
      });
    },
    updateMaxSelectedIngestList () {
      this.maxSelected = [];
      this.mealTypes.forEach(type => {
        if (this.plans.filter(plan => plan.type === type && plan.active).length >= this.maxTypePlans) {
          const typeIndex = this.mealTypes.findIndex((e) => e === type);
          this.maxSelected.push(this.$t('health.nutritionalPlan.mealTypes')[typeIndex]);
        }
      });
    },
    isActive (id) {
      const foundPlans = this.plans.filter(value => value.id === id);
      return foundPlans.length > 0 && foundPlans[0].active;
    },
    onDelete (plan) {
      this.planToDelete = plan;
      this.deleteModalMessage = this.$t('health.nutritionalPlan.delete');
      this.showConfirmationDeleteModal = true;
    },
    onUpdate (plan) {
      this.$router.push({name: 'Ingest', params: {mode: 'edit', userId: this.selectedUser, plan: plan, weight: this.weight, planMode: this.mode}});
    },
    onDeleteConfirm () {
      const id = this.planToDelete.id;
      const planName = this.planToDelete.name;
      this.planToDelete = {};
      this.showConfirmationDeleteModal = false;
      api.deletePlan(this, id).then(() => {
        showAlert(this, this.$t('health.nutritionalPlan.successDelete', {name: planName}), 'success');
        this.plans = this.plans.filter(value => value.id !== id);
      }, () => {
        showAlert(this, this.$t('health.nutritionalPlan.errorDelete', {name: planName}), 'error');
      });
    },
    onDeleteCancel () {
      this.planToDelete = {};
      this.showConfirmationDeleteModal = false;
    },
    createPlan () {
      this.$router.push({
        name: 'Ingest',
        params: {mode: 'create', userId: this.selectedUser, weight: this.weight, planMode: this.mode}
      });
    },
    onNutritionalModeSelected (mode) {
      this.mode = mode;
      api.updateNutritionPlanMode(this, this.selectedUser, mode.alias).then(() => {
        showAlert(this, this.$t('health.nutritionalPlan.successUpdateMode'), 'success');
      }, () => {
        showAlert(this, this.$t('health.nutritionalPlan.errorUpdateMode', 'error'));
      });
    },
    isModeChecked (mode) {
      return this.mode !== undefined &&
      this.mode !== null &&
      this.mode.id === mode.id ? 'checked' : '';
    },
    maxIngestSelected (row) {
      const activeIngest = this.plans.filter(plan => plan.type === row.type && plan.active);
      return activeIngest.length >= this.maxTypePlans;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}

.header-title {
  float: left;
}

.right {
  float: right;
  padding-right: 5%;
}

.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}

.warning-icon {
  font-size: 1.5rem;
  color: $secondary;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/IngestList.vue